import { z } from "zod";

export const nameFormSchema = z.object({
  firstName: z
    .string()
    .min(1, "nameFormErrors:nameErrorRequired")
    .max(50, "nameFormErrors:nameErrorMaxLength"),
});
